module.exports = __webpack_public_path__ + "img/bkd.ab42a9f2.png";